function doesClauseReferenceMatch(refA, refB) {
  return refA === refB || refA.startsWith(`${refB}.`);
}

export default doesClauseReferenceMatch;
